module.exports = __webpack_public_path__ + "static/media/mptc-student-logo.cfd135c1.svg";